export default __webpack_public_path__ + "static/media/bp_logo-black.f808f9b7.svg";